import { useState } from "react";
import Config from "../../Config";
import InputSearchEmp from "../../helpers/InputSearchEmp";


import back from "../../back.png";
//import XDateFee from "./XDateFee";
//import XTime from "./XTime";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import XTime from "../kids/XTime";



function Start(props)
{

    var dt = new Date();

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [row, setRowX] = useState({  
        fraza:  "",   
        px_group_id: -1,       
        profil:  null,   
        miesiac: dt.getMonth()+1,
        rok: dt.getFullYear(),        
    });
    var tmpRow = row;

    const [tabKalendar, setTabKalendarz] = useState(null);
    const [tabWejsciaWyjscia, setTabWejsciaWyjscia] = useState(null);
    const [tabGodziny, setTabGodziny] = useState(null);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [goAllRefresh, setGoAllRefresh] = useState(0);


    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 



    const [lata, setLata] = useState(null);
    const [miesiace, setMiesiace] = useState(null);



    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );        
        setGoAllRefresh(1);     
    }   


    const goNextNew = () => {
        console.log("goNext");
      //  saveData();
    }


    
    const empSelected = (id) => { 
        setRowX( {...row, ['px_group_id']:id  } );

        if(id == -1 ) return;
        getProfile(id);
        getAll(id);
    }


    const onBack = () => {


        if(props.onBack != undefined && props.onBack != null)
        {
            props.onBack();
            return;
        }

        setRowX( {...row, ["id"]:-1, ["fraza"]: "", ["profil"]: null   }  ); 
    }



    
    const getLata = () => {
       
 
        var y = new Array();

 
       

        var dt = new Date();

        var next = dt.getFullYear()+1;
        y.push({
            v: next,
            title: next
        }); 


        for(var k=dt.getFullYear(); k>2011; k--)
            {
                y.push({
                    v: k,
                    title: k
                }); 
            }

        setLata(y);      
 
    }


    const getMiesiace = () => {
       
 
        var y = new Array();
 

        y.push({
            v: '01',
            title: 'Styczeń'
        });


        y.push({
            v: '02',
            title: 'Luty'
        });

        y.push({
            v: '03',
            title: 'Marzec'
        });

        y.push({
            v: '04',
            title: 'Kwiecień'
        });


        y.push({
            v: '05',
            title: 'Maj'
        });

        y.push({
            v: '06',
            title: 'Czerwiec'
        });

        y.push({
            v: '07',
            title: 'Lipiec'
        });

        y.push({
            v: '08',
            title: 'Sierpień'
        });


        y.push({
            v: '09',
            title: 'Wrzesień'
        });

        y.push({
            v: '10',
            title: 'Październik'
        });

        y.push({
            v: '11',
            title: 'Listopad'
        });

        y.push({
            v: '12',
            title: 'Grudzień'
        });

        setMiesiace(y);      
 
    }

 

    const getAll = (id) => {

        var tmpId = row.px_group_id;

        if(id != undefined && id != null && id > 0) tmpId = id;

        if(tmpId == -1) return;

        getCal();  
        getTabWejsciaWyjscia(tmpId);   
        getTabGodziny(tmpId);  
    }


    const getProfile = (id) => {
       
 
        if(id == -1) return;

        props.mainView.setProgress(-2);


        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_emps,profile', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       setRowX({ ...row, ["profil"]: res.result }) ;                     
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getCal = () => {
       
 
    

        props.mainView.setProgress(-2);       

        fetch( Config.url + '/rest_v1_emps,calendar', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabKalendarz(res.result);                           
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const getTabWejsciaWyjscia = (id) => {
       
 
        

        props.mainView.setProgress(-2);


        var t = row;
        if(id != undefined && id != null && id > 0)  t["px_group_id"] = id;
       

        fetch( Config.url + '/rest_v1_emps,inout_v', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabWejsciaWyjscia(res.result);                               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const getTabGodziny = (id) => {
       
 
        props.mainView.setProgress(-2);


        var t = row;
        if(id != undefined && id != null && id > 0)  t["px_group_id"] = id;
       

        fetch( Config.url + '/rest_v1_emps,hour_v', {
            method: 'POST', 
            body: JSON.stringify(t), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTabGodziny(res.result);            
                              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(goAllRefresh == 1)
        {
            setGoAllRefresh(0);
            getAll();
        }





    if(refreshView != props.userData.refreshView)
        {
            setRefreshView( props.userData.refreshView);   
                     
            setRowX({  
                fraza:  "",       
                px_group_id: -1,   
                profil:  null,   
                miesiac: dt.getMonth()+1,
                rok: dt.getFullYear(),        
            });

        }


    if(row.profil == null)
            {
                document.title = "Szukaj: " + row.fraza;
    
    
                return <div className="view_content">
    
                              
    
                                <form className="eForm bg_center">
    
                                            <div className="form_tab">
    
                                            <div className="form_control">
                                                    <div className="fieldName">Pracownik</div>
                                                    <InputSearchEmp  mainView={props.mainView} userData={props.userData}   err={errTab} empSelected={empSelected} valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Pracownik: "} className=' w250 ' req='1' firstUp="1" />
                                                </div>
    
                                            </div>
    
                                </form>        
    
                </div>
    }



    if(lata == null)  {
        getLata();
    }


    if(miesiace == null)  {
        getMiesiace();
    }




    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {
        //param1 = 'YYYY-mm-dd'
        // param2 = 'I // O
        //param3,  id -- p_rejestr_id , lub puste..


        console.log("XTime ", hm, param1, param2, param3, param4);


        props.mainView.setProgress(-2);

       
        var req = {
            px_group_id: row.px_group_id,
            p_rejestr_id: param3,
            dzien: param1,
            hm: hm,   
            operacja: param2,         
        };


        fetch( Config.url + '/rest_v1_emps,inout_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       getAll(row.p_dziecko_id);
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

  }


    if(goAllRefresh == 1)
    {
        setGoAllRefresh(0);
        getAll();
    }



    if(tabWejsciaWyjscia  == null)
        {
            return <div>
                ..............
            </div>
        }


    if(tabGodziny  == null)
            {
                return <div>
                    ..............
                </div>
            }



    document.title = row.profil.imie + " " + row.profil.nazwisko;



    return <div className="view_content">

        
                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>


                <h1>{row.profil.imie + " " + row.profil.nazwisko}</h1>



                <div className="table_filter">

                    <div className="filter_controll">   
                            <label>Rok: </label>                             
                            <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={row.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                    </div> 

                    <div className="filter_controll">   
                            <label>Miesiąc: </label>                             
                            <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={row.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                    </div>
                </div> 



        
                <div className="bg_center">

                        <table className="table">
                                    <thead>
                                        <tr className="header">
                                            <td className="td_left"></td>
                                            <td></td>
                                            {
                                                tabKalendar.map( (calDay, inx) => {

                                                    if(inx >15) return null;

                                                    return <td>
                                                        {calDay.d}
                                                    </td>

                                                } )

                                            }
                                        </tr>
                                    </thead>

                                    <tbody>



                                        <tr className="row">
                                            <td>Przybycie</td>
                                            <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";

                                                        var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3='-1' param4='' /> 

                                                        for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                        {
                                                            if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "I" )
                                                            {
                                                                tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={ tabWejsciaWyjscia[io].id} param4='' />
                                                                break;
                                                            }
                                                        }

                                                        return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                    } )

                                                }
                                        </tr> 


                                        <tr className="row">
                                            <td>Wyjście</td>
                                            <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";


                                                        var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "O" }  param3='-1' param4='' /> 

                                                        for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                        {
                                                            if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "O" )
                                                            {
                                                                tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={tabWejsciaWyjscia[io].id} param4='' />
                                                                break;
                                                            }
                                                        }

                                                        return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                    } )

                                                }
                                        </tr> 



                                        <tr className="row">
                                            <td>Godziny (faktyczne)</td>
                                            <td>-</td>
                                            {
                                                  tabKalendar.map( (calDay, inx) => {

                                                       if(inx >15) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";

                                                        var tdContent = <span>--:--</span>;



                                                        for(var io=0; io < tabGodziny.length; io++)
                                                            {
                                                                if(tabGodziny[io].dzien == calDay.dzien  )
                                                                {
                                                                    tdContent =  <span>{tabGodziny[io].faktyczne_hm}</span>
                                                                    break;
                                                                }
                                                            }


                                                            return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                  } )
                                            }
                                        </tr>    


                                     


                                    </tbody>
                        </table>
                </div>

 <div className="bg_center">

                        <table className="table">
                                    <thead>
                                        <tr className="header">
                                            <td className="td_left"></td>
                                            <td></td>
                                            {
                                                tabKalendar.map( (calDay, inx) => {

                                                    if(inx <16) return null;

                                                    return <td>
                                                        {calDay.d}
                                                    </td>

                                                } )

                                            }
                                        </tr>
                                    </thead>

                                    <tbody>



                                        <tr className="row">
                                            <td>Przybycie</td>
                                            <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx <16) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";

                                                        var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3='-1' param4='' /> 

                                                        for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                        {
                                                            if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "I" )
                                                            {
                                                                tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={ tabWejsciaWyjscia[io].id} param4='' />
                                                                break;
                                                            }
                                                        }

                                                        return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                    } )

                                                }
                                        </tr> 


                                        <tr className="row">
                                            <td>Wyjście</td>
                                            <td>-</td>
                                                {
                                                    tabKalendar.map( (calDay, inx) => {

                                                        if(inx <16) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";


                                                        var tdContent =   <XTime title={ calDay.dzien} hour={ "00" } minute={ "00" }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "O" }  param3='-1' param4='' /> 

                                                        for(var io=0; io < tabWejsciaWyjscia.length; io++)
                                                        {
                                                            if(tabWejsciaWyjscia[io].dzien == calDay.dzien && tabWejsciaWyjscia[io].operacja == "O" )
                                                            {
                                                                tdContent =  <XTime title={ calDay.dzien} hour={ tabWejsciaWyjscia[io].h } minute={ tabWejsciaWyjscia[io].i }  onChange={onChangeXTime} param1={ calDay.dzien } param2={ "I" }  param3={tabWejsciaWyjscia[io].id} param4='' />
                                                                break;
                                                            }
                                                        }

                                                        return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                    } )

                                                }
                                        </tr> 


                                        <tr className="row">
                                            <td>Godziny (faktyczne)</td>
                                            <td>-</td>
                                            {
                                                  tabKalendar.map( (calDay, inx) => {

                                                    if(inx <16) return null;

                                                        var colCss = "";

                                                        if(calDay.w == 6) colCss = "e_squere_sb";
                                                        if(calDay.w == 0) colCss = "e_squere_nd";

                                                        var tdContent = <span>--:--</span>;



                                                        for(var io=0; io < tabGodziny.length; io++)
                                                            {
                                                                if(tabGodziny[io].dzien == calDay.dzien  )
                                                                {
                                                                    tdContent =  <span>{tabGodziny[io].faktyczne_hm}</span>
                                                                    break;
                                                                }
                                                            }


                                                            return <td className={ "gocenter " + colCss}>
                                                            {tdContent}
                                                        </td>

                                                  } )
                                            }
                                        </tr>    


                                       

                                        


                                    </tbody>
                        </table>
                </div>

             


    </div>
}


export default Start;